import React, { Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import useRoutes from './useRoutes';

// Сторінки вантажаться через lazy, тож потрібен запасний вміст на час
// підвантаження чанка. Раніше весь код усіх сторінок лежав в одному файлі:
// той, хто відкрив карту, тягнув і статистику, і генератор QR, і аналітику.
const PageFallback = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
    <CircularProgress />
  </Box>
);

const Router = () => {
  const routes = useRoutes();

  const nestedRoutes = routes
    .filter(route => route.nested)
    .map(route => route.nested)
    .flat();

  return (
    <Suspense fallback={<PageFallback />}>
      <Switch>
        <Route exact path="/">
          <Redirect to="/control" />
        </Route>
        {nestedRoutes.map(route => {
          return (
            <Route
              component={route!.component}
              key={route!.path}
              path={route!.path}
            />
          );
        })}
        {routes.map(route => {
          return (
            <Route
              component={route.component}
              key={route.path}
              path={route.path}
            />
          );
        })}
      </Switch>
    </Suspense>
  );
};

export default Router;
